import { MeasuredEmissionSourceByRegion } from "../../api/models/Dashboard";
import { ragToBgClassMap, ragToRgb } from "../../constants";
import Card from "../Card";
import RegionalMap from "./RegionalMap";
import GridTable from "./GridTable";
import HorizontalBar from "./HorizontalBar";
import CertaintyRagChip from "./CertaintyRagChip";

export type ByRegionMeasuredCertaintyProps = {
    measuredEmissionsSourcesByRegion: MeasuredEmissionSourceByRegion[];
};

const ByRegionMeasuredCertainty = ({
    measuredEmissionsSourcesByRegion,
}: ByRegionMeasuredCertaintyProps) => {
    const data = measuredEmissionsSourcesByRegion.map((_) => ({
        id: _.regionId,
        name: _.regionName,
        redCount:
            _.missingEmissionsFactorCount +
            _.poorConfidenceCurrentEmissionsFactorsDataSourceCount,
        amberCount: _.fairConfidenceCurrentEmissionsFactorsDataSourceCount,
        greenCount: _.highConfidenceCurrentEmissionsFactorsDataSourceCount,
        color:
            _.missingEmissionsFactorCount +
                _.poorConfidenceCurrentEmissionsFactorsDataSourceCount >
            0
                ? ragToRgb.red
                : _.fairConfidenceCurrentEmissionsFactorsDataSourceCount > 0
                ? ragToRgb.amber
                : ragToRgb.green,
    }));

    const ragTotalMax = Math.max(
        ...data.map((_) => _.redCount + _.amberCount + _.greenCount)
    );

    return (
        <div className="flex lg:space-x-6 items-center">
            <Card className="hidden lg:block bg-white border-surface-light-5 border-2 shrink-0 w-[350px] p-2">
                <RegionalMap regionColors={data} />
            </Card>
            <GridTable
                gridTemplateColumns="1fr 120px 1fr 150px"
                data={data}
                headings={[
                    { label: "Region" },
                    { label: "Count " },
                    { label: "Breakdown" },
                    { label: "Overall" },
                ]}
                renderRow={(rowData) => (
                    <>
                        <div className="px-4 py-3 whitespace-nowrap overflow-hidden text-ellipsis">
                            {rowData.name}
                        </div>
                        <div className="px-4 py-3 whitespace-nowrap overflow-hidden text-ellipsis">
                            {rowData.amberCount +
                                rowData.greenCount +
                                rowData.redCount}
                        </div>
                        {rowData.redCount +
                            rowData.amberCount +
                            rowData.greenCount >
                        0 ? (
                            <HorizontalBar
                                data={[
                                    {
                                        value: rowData.redCount,
                                        color: ragToBgClassMap["red"],
                                    },
                                    {
                                        value: rowData.amberCount,
                                        color: ragToBgClassMap["amber"],
                                    },
                                    {
                                        value: rowData.greenCount,
                                        color: ragToBgClassMap["green"],
                                    },
                                ]}
                                total={ragTotalMax}
                            />
                        ) : (
                            <p className="text-gray-400">No data</p>
                        )}
                        <div className="px-4 py-2">
                            <CertaintyRagChip
                                red={rowData.redCount}
                                amber={rowData.amberCount}
                            />
                        </div>
                    </>
                )}
            />
        </div>
    );
};

export default ByRegionMeasuredCertainty;
